export const useFormatHours = (hours: number) => {
    const n = new Date(0,0)
    n.setSeconds(+hours * 60 * 60)
    return n.toTimeString().slice(0, 8)
  }

export const formatHours = useFormatHours